interface SponsorLogosProps {
  logos: string[];
  title?: string;
}

export function SponsorLogos({ logos, title = "Supported by" }: SponsorLogosProps) {
  return (
    <div className="w-full max-w-6xl mx-auto px-4 mt-12 mb-20">
      <h3 className="text-center text-white text-sm font-medium mb-8 uppercase tracking-wider">
        {title}
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
        {logos.map((logo, index) => (
          <div
            key={index}
            className="bg-white/80 backdrop-blur-sm rounded-lg p-4 shadow-sm hover:shadow-md transition-all duration-300 hover:scale-105 flex items-center justify-center h-60"
          >
            <img
              src={logo}
              alt={`Sponsor ${index + 1}`}
              className="max-w-full max-h-32 object-contain opacity-70 hover:opacity-100 transition-opacity duration-300"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
